// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"74f00e58","726":"168269e0"}[chunkId] + ".chunk.js";
};